import PropTypes from 'prop-types';

export default function Infobox({ children, type = 'primary' }) {
	return (
		<div className="feature__infobox">
			<div className={`infobox infobox--${type}`}>
				<p>{children}</p>
			</div>
		</div>
	);
}

Infobox.propTypes = {
	children: PropTypes.node.isRequired,
	type: PropTypes.string,
};
